import React, { memo } from "react";
import classes from "./DescriptionCell.scss";
import { useI18n } from "Hooks";
import { getStyleStrippedText } from "Utils";
import _ from "lodash";

const CELL_NAME = "subText";

const DescriptionCell = ({
  onContentEdit,
  value,
  mode,
  onBulkPasteRows,
  updateDraftNode,
}) => {
  const { t } = useI18n(["common", "scopeAndSequence"]);

  const handleContentEdit = event => {
    event.stopPropagation();
    const updatedValue = getStyleStrippedText({
      text: event.currentTarget.innerHTML,
      type: "SNS_EDITOR",
    });

    const prevValue = value;

    if (updatedValue !== prevValue) {
      const params = {
        [CELL_NAME]: updatedValue,
      };
      onContentEdit({ params });
    }
  };

  const isValueEmpty = _.isEmpty(value);

  const placeholderText = t("common:enter_with_label", {
    label: t("common:description"),
  });

  const handleOnPaste = event => {
    const pastedData = event.clipboardData.getData("Text"); // TODO: Handle image paste for equation editor images
    const itemsList = pastedData.split(/\r?\n/); // regex spitting the excel sheet data into a list;
    const itemsListLength = _.size(itemsList);
    if (itemsListLength > 1) {
      // the list will be pasted in row format
      event.preventDefault();
      onBulkPasteRows({
        pastedData,
        cellName: CELL_NAME,
        isNewRow: false,
        itemsList,
      });
    }
  };

  const handleOnInput = event => {
    const updatedLabel = getStyleStrippedText({
      text: event.currentTarget.innerHTML,
      type: "SNS_EDITOR",
    });
    // const updatedLabel = event.currentTarget.textContent;
    updateDraftNode({ cellName: CELL_NAME, labelValue: updatedLabel });
  };

  return (
    <div
      className={classes.valueContainer}
      contentEditable={mode === "edit"}
      onBlur={handleContentEdit}
      suppressContentEditableWarning={true}
      // eslint-disable-next-line react/no-unknown-property
      placeholdertext={isValueEmpty ? placeholderText : ""}
      dangerouslySetInnerHTML={{
        __html: isValueEmpty ? (mode === "view" ? "--" : "") : value,
      }}
      onPasteCapture={handleOnPaste}
      onInput={handleOnInput}
    />
  );
};

export default memo(DescriptionCell);
